import React from "react";
import TranscationActivity from "../PureComponents/TranscationActivity";

const RenderTranscationActivity = () => {
  return <TranscationActivity />;
};

export default RenderTranscationActivity;
